import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "designSystem/components/button/IconButton";
import { Checkbox, FlexRowCenter, SingleSelect } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { GroupingLevel, useCustomViewGroupingStore } from "./CustomViewGroupingStore";

interface CustomViewGroupingLevelProps {
	/** grouping level */
	level: GroupingLevel;
}

const CustomViewGroupingLevel: FunctionComponent<CustomViewGroupingLevelProps> = observer(({ level }) => {
	const {
		checkExpandRules,
		generateDropDownValues,
		groupingList,
		groupOptions,
		isLevelDisabled,
		removeGroupingLevel,
		setGroupingLevel,
	} = useCustomViewGroupingStore();

	const index = groupingList.indexOf(level);

	const {
		expand,
		item,
	} = groupingList[index];

	return (
		<FlexRowCenter
			bgcolor={grey[100]}
			data-csi-automation="CustomViewGroupingLevel"
			justifyContent="space-between"
			marginY={2}
			pl={4}
			py={2}
			sx={{ border: STANDARD_BORDER_STYLE, borderRadius: 1 }}
		>
			<FlexRowCenter gap={2} growNoOverflow>
				<SingleSelect
					disableClearable
					forcePopupIcon
					groupBy={(option) => option.group}
					onChange={(event, value, reason) => setGroupingLevel(value, index)}
					onOpenCallback={generateDropDownValues}
					options={groupOptions(item)}
					preferReactVirtuoso
					sx={{ width: 231 }}
					value={item}
				/>
				<Checkbox
					checked={expand}
					disabled={isLevelDisabled(index)}
					labelProps={{
						res: "CustomViewExpandByDefault",
					}}
					onChange={(event, checked) => checkExpandRules(checked, index)}
				/>
			</FlexRowCenter>
			<FlexRowCenter>
				<IconButton
					onClick={() => removeGroupingLevel(index)}
					size="large"
				>
					<ClearIcon />
				</IconButton>
			</FlexRowCenter>
		</FlexRowCenter>
	);
});

export default CustomViewGroupingLevel;